import React, { useEffect, useState } from "react";
import "./Category.css";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import Sidebar from "../components/Sidebar";
import { useJwt } from "react-jwt";
// import { GetFeedbackPage, Getblinkit } from "../apiconfig/authService";
import { Pagination } from "rsuite";
import "rsuite/dist/rsuite.min.css";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function Blinkit(props) {
    const navigate = useNavigate();
    const { isExpired } = useJwt(
        localStorage.getItem("accessToken")
    );
    if (isExpired) navigate("/");
    const today = new Date();
    const message = props.message;
    const [startDate, setStartDate] = useState(today);
    const [endDate, setEndDate] = useState(today);
    // const [categoriesData, setCategoriesData] = useState([]);
    const [feedbacksData, setFeedbacksData] = useState([]);
    const [totalFeedbacks, setTotalFeedbacks] = useState();
    const [pincode, setPincode] = useState([]);
    const [Selectpincode, setSelectpincode] = useState("122001");

    const [search, setSearch] = useState("");
    const [page, setPage] = useState(1);
    const [pageCount, setPageCount] = useState(0);
    // const [totalCategories, setTotalCategories] = useState(0);
    const [itemsPerPage, setItemsPerPage] = useState(25);
    // const [recordIdToDelete, setRecordIdToDelete] = useState("");
    const [refetchData, setRefetchData] = useState(false);
    const [selectedRows, setSelectedRows] = useState({});
    const [selectAll, setSelectAll] = useState(false);
    const [selectedData, setSelectedData] = useState({});
    const [loadingRows, setLoadingRows] = useState({});

    // const [showButton, setShowButton] = useState(false);
    const handlePerPageRecordsChange = (e) => {
        setItemsPerPage(e.target.value);
        setPageCount(1);
    };

    console.log(feedbacksData);

    const formatUTCDate = (utcDateString) => {
        if (!utcDateString) return null;

        const date = new Date(utcDateString);
        if (isNaN(date.getTime())) return null; // Handle invalid date

        // Convert UTC date to local date (YYYY-MM-DD format)
        return date.toLocaleDateString("en-CA"); // "YYYY-MM-DD"
    };
    useEffect(() => {
        (async () => {
            try {
                const queryParams = {
                    pincode: Selectpincode,
                    page,
                    itemsPerPage,
                    search,
                    startDate: startDate ? startDate.toISOString().split('T')[0] : null,
                    endDate: endDate ? endDate.toISOString().split('T')[0] : null,
                };
                console.log("queryParams", queryParams);
                // const queryParams = await Getblinkit(queryParams, localStorage.getItem('accessToken'));
                const feedbacksData = await axios.get(
                    "https://scrapbackend.pikeazy.in/store/getblinkit",
                    { params: queryParams }
                );
                setFeedbacksData(feedbacksData.data.items);
                // console.log("eedbacksData.data.items??????", feedbacksData.data.items);
                // console.log("eedbacksData.data.items??????", feedbacksData.data.items);
                setPincode(feedbacksData.data.items.pincodeinfo);
                setPageCount(Math.ceil(feedbacksData.data.pagination.pageCount));
                setTotalFeedbacks(feedbacksData.data.pagination.count);
            } catch (error) {
                console.log(error);
            }
        })();
    }, [page, itemsPerPage, refetchData, Selectpincode, startDate, endDate]);

    const handleSearchBoxSubmit = (event) => {
        event.preventDefault();
        setPage(1);
        setRefetchData(!refetchData);
    };
    const handleSelectAll = () => {
        const allSelected = !selectAll; // Toggle the selectAll state
        setSelectAll(allSelected);

        const updatedSelectedRows = {};
        const updatedSelectedData = {};

        if (allSelected) {
            // Select all rows
            feedbacksData.forEach((item) => {
                updatedSelectedRows[item._id] = true;
                updatedSelectedData[item._id] = {
                    productId: item.productid,
                    blinkitid: item.blinkitid,
                };
            });
        }

        setSelectedRows(updatedSelectedRows);
        setSelectedData(updatedSelectedData);

        console.log("All rows selected:", updatedSelectedData);
    };

    const handleRowSelect = (id, productId, blinkitid) => {
        const updatedSelectedRows = { ...selectedRows, [id]: !selectedRows[id] };

        // console.log("updatedSelectedRows", updatedSelectedRows);
        setSelectedRows(updatedSelectedRows);

        // Update the list of selected product and Zepto IDs
        const updatedSelectedData = { ...selectedData };
        if (updatedSelectedRows[id]) {
            updatedSelectedData[id] = { productId, blinkitid };
        } else {
            delete updatedSelectedData[id];
        }

        setSelectedData(updatedSelectedData);

        // console.log("Selected data (product and Zepto IDs):", updatedSelectedData);

        // Optionally update a "Select All" state
        const allSelected = feedbacksData.every(
            (item) => updatedSelectedRows[item._id]
        );
        // console.log("allSelected", allSelected);
        setSelectAll(allSelected);
    };

    const handleUpload = async (_id, productid, blinkitid) => {
        // Check if any row is selected
        const selectedEntries = Object.values(selectedData);
        if (selectedEntries.length === 0) {
            toast.warning("Please select at least one row before uploading.", {
                position: "top-right",
                autoClose: 1000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
            });
            return;
        }

        // Mark all selected rows as loading
        const loadingState = {};
        Object.keys(selectedData).forEach((id) => {
            loadingState[id] = true;
        });
        setLoadingRows(loadingState);

        const pincode = Selectpincode; // your desired pincode
        try {
            const response = await fetch(
                `https://scrapbackend.pikeazy.in/manual/getProductsBlinkitManual?pincode=${pincode}`,
                {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({ products: Object.values(selectedData) }),
                }
            );

            const data = await response.json();
            toast.success("Manual scrapping initiated successfully!", {
                position: "top-right",
                autoClose: 1000,
            });
            // Second API call (after the first one succeeds)
            const secondPayload = {
                productInfo: Object.values(selectedData).map(entry => ({
                    store: "blinkit",
                    productid: entry.blinkitid, // e.g. "491377382" or "603826945"
                })),
            };

            const secondResponse = await fetch(
                `https://scrapbackend.pikeazy.in/product/productPriceRangeManual?pincode=${pincode}`,
                {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify(secondPayload),
                }
            );

            const secondData = await secondResponse.json();
            console.log("Second API Response:", secondData);
            toast.success("Manual scrapping initiated successfully!", {
                position: "top-right",
                autoClose: 1000,
            });
            // Optionally update state with the API response here
        } catch (error) {
            console.error("Error during manual scrapping:", error);
            toast.error("Failed to initiate manual scrapping!", {
                position: "top-right",
                autoClose: 1000,
            });
        } finally {
            // Remove the loading indicator for all selected rows
            const loadingReset = {};
            Object.keys(selectedData).forEach((id) => {
                loadingReset[id] = false;
            });
            setLoadingRows(loadingReset);
        }
    };
    const isCurrentDate = (date) => {
        if (!date) return false; // Handle null/undefined cases
        console.log("c?", date);

        const formattedToday = formatUTCDate(new Date()); // Format today's date in local time
        const formattedItemDate = formatUTCDate(date); // Convert input date to local format

        if (!formattedItemDate) return false; // Handle invalid date

        // console.log(`Checking date: ${formattedItemDate} against ${formattedToday}`);

        return formattedItemDate === formattedToday;
    };
    // console.log("isCurrentDate??????", isCurrentDate)
    // useEffect(() => {
    //     const hasCurrentDateData = feedbacksData.some(item => isCurrentDate(item.createddate));
    //     setShowButton(hasCurrentDateData);
    // }, [feedbacksData]);
    return (
        <div className="dashboard-content">
            <Sidebar />
            <div className="body-cart tab-content dasContent p-4 bg-white rounded">
                <div className="d-flex justify-content-between align-items-start pb-4 border-bottom mb-4">
                    <h1 className="heading h4 mb-0 fw-bold">
                        Blinkit Management
                        <br />
                        <small className="text-primary h6 fw-bold">
                            Total counts {totalFeedbacks}
                        </small>
                    </h1>
                    <div className="d-inline-flex gap-2">
                        <button
                            type="button"
                            className="btn btn-primary"
                            onClick={handleUpload}
                        >
                            Manual Scrapping
                        </button>

                        {/* {showButton && (
                            <div className="d-inline-flex gap-2">
                                <button type="button" className="btn btn-primary" onClick={handleUpload}>
                                    Manual Scrapping
                                </button>
                            </div>
                        )} */}
                    </div>
                </div>

                <div className="searchList row g-3 align-items-end">
                    {/* Display Records Section */}
                    <div className="col-lg-2 col-md-3 col-sm-4">
                        <label className="form-label">Display Records</label>
                        <select
                            className="form-select"
                            value={itemsPerPage}
                            onChange={handlePerPageRecordsChange}
                        >
                            <option value="25">25</option>
                            <option value="50">50</option>
                            <option value="75">75</option>
                            <option value="100">100</option>
                            <option value="250">250</option>
                        </select>
                    </div>

                    {/* Pincode Dropdown */}

                    <div className="col-lg-2 col-md-3 col-sm-4 h-50">
                        <label className="form-label">Select Pincode</label>
                        <select
                            className="form-select"
                            value={Selectpincode}
                            onChange={(e) => setSelectpincode(e.target.value)}
                        >
                            <option value="122001">122001</option>
                            <option value="122002">122002</option>
                        </select>
                    </div>

                    {/* Date Filters */}
                    <div className="col-lg-4 col-md-6 col-sm-8">
                        <form onSubmit={handleSearchBoxSubmit}>
                            <div className="row">
                                <div className="col">
                                    <label className="form-label">Start Date</label>
                                    <DatePicker
                                        selected={startDate}
                                        onChange={(date) => setStartDate(date)}
                                        className="form-control"
                                        dateFormat="dd-MM-yyyy"
                                        placeholderText="Select start"
                                    />
                                </div>
                                <div className="col">
                                    <label className="form-label">End Date</label>
                                    <DatePicker
                                        selected={endDate}
                                        onChange={(date) => setEndDate(date)}
                                        className="form-control"
                                        dateFormat="dd-MM-yyyy"
                                        placeholderText="Select end"
                                    />
                                </div>
                                <div className="col-auto d-flex align-items-end">
                                    <button type="submit" className="btn btn-primary">
                                        Filter
                                    </button>
                                </div>
                            </div>
                        </form>
                    </div>

                    {/* Search Box */}
                    <div className="col-lg-2 col-md-3 col-sm-4 text-end">
                        <form className="sForm w-100" onSubmit={handleSearchBoxSubmit}>
                            <input
                                type="text"
                                onChange={(event) => setSearch(event.target.value)}
                                className="form-control form-control-sm"
                                placeholder="Search"
                                style={{ height: '38px' }}  // Adjust height to match DatePicker
                            />
                        </form>
                    </div>
                </div>

                {message && (
                    <div className="alert alert-primary" role="alert">
                        {message}
                    </div>
                )}

                <div className="table-responsive">
                    <table className="table table-borderless table-hover my-3">
                        <thead>
                            <tr>
                                <th scope="col" width="45" align="center">
                                    <div className="selectAll">
                                        <input
                                            className="form-check-input"
                                            type="checkbox"
                                            checked={selectAll}
                                            onChange={handleSelectAll}
                                            aria-label="Select all rows"
                                        />
                                    </div>
                                </th>
                                <th scope="col" width="80">
                                    <span>SR.</span>
                                </th>
                                <th scope="col">
                                    <span>Productid</span>
                                </th>
                                <th scope="col">
                                    <span>Product Name</span>
                                </th>
                                <th scope="col">
                                    <span>Blinkitid</span>
                                </th>
                                <th scope="col">
                                    <span>ispopular</span>
                                </th>
                                <th scope="col">
                                    <span>Code</span>
                                </th>
                                <th scope="col">
                                    <span>Message</span>
                                </th>
                                <th scope="col">
                                    <span>Pincode</span>
                                </th>
                                <th scope="col">
                                    <span>BlinkitPrice</span>
                                </th>
                                <th scope="col">
                                    <span>BlinkitQuantity</span>
                                </th>
                                <th scope="col">
                                    <span>Availability</span>
                                </th>
                                <th scope="col">
                                    <span>IsScrape</span>
                                </th>
                                <th scope="col">
                                    <span>Created Date</span>
                                </th>
                                <th scope="col">
                                    <span>Modified Date</span>
                                </th>
                                <th scope="col">
                                    <span>Scrape</span>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            {feedbacksData.map((item, index) => {
                                // console.log(`Item ID: ${item.productid}, Created Date:`, item.createddate); // Log the createddate

                                return (
                                    <tr key={item._id}>
                                        <td>
                                            <input
                                                className="form-check-input"
                                                type="checkbox"
                                                checked={!!selectedRows[item._id]}
                                                onChange={() =>
                                                    handleRowSelect(
                                                        item?._id,
                                                        item?.productid,
                                                        item?.blinkitid
                                                    )
                                                }
                                                aria-label={`Select row for product ${item?.productid}`}
                                            />
                                        </td>
                                        <td>{index + 1}</td>
                                        <td>{item?.productid}</td>
                                        <td>{item?.productname}</td>
                                        <td>{item?.blinkitid}</td>
                                        <td>{item?.ispopular}</td>
                                        {item.pincodeinfo.map((pincodeItem, pIndex) => (
                                            <React.Fragment key={pIndex}>
                                                <td>{pincodeItem?.code}</td>
                                                <td>{pincodeItem?.message}</td>
                                                <td>{pincodeItem?.pincode}</td>
                                                <td>{pincodeItem?.blinkitprice}</td>
                                                <td>{pincodeItem?.blinkitquantity}</td>
                                                <td>{pincodeItem?.availiblity}</td>
                                                <td>{pincodeItem?.isScrape ? "Yes" : "No"}</td>
                                            </React.Fragment>
                                        ))}
                                        <td>{formatUTCDate(item?.createddate)}</td>
                                        <td>{formatUTCDate(item?.modifieddate)}</td>                                        <td>
                                            {/* Show button only if the record is from today */}
                                            {isCurrentDate(item?.createddate) ? (
                                                <button
                                                    type="button"
                                                    className="btn btn-sm btn-primary"
                                                    onClick={() => handleUpload(item?._id, item?.productid, item?.blinkitid)}
                                                    disabled={loadingRows[item?._id]}  // disable button while loading
                                                >
                                                    {loadingRows[item?._id] ? (
                                                        // Spinner for visual feedback (using Bootstrap spinner)
                                                        <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                                    ) : (
                                                        "Manual"
                                                    )}
                                                </button>

                                            ) : null}
                                        </td>
                                    </tr>
                                );
                            })}

                        </tbody>
                    </table>
                </div>

                <div className="resultList pt-3 border-top">
                    <div className="d-flex justify-content-between displayRecord">
                        {totalFeedbacks === 0 ? (
                            <div>Showing 0 - 0 of 0 entries.</div>
                        ) : (
                            <div>
                                Showing {(page - 1) * itemsPerPage + 1} -{" "}
                                {Math.min(itemsPerPage * page, totalFeedbacks)} of{" "}
                                {totalFeedbacks} entries.
                            </div>
                        )}

                        <Pagination
                            prev
                            last
                            next
                            first
                            size="sm"
                            ellipsis
                            boundaryLinks
                            onSelect={setPage}
                            limit={itemsPerPage}
                            onChangeLimit={setItemsPerPage}
                            layout={["pager", "skip"]}
                            pages={pageCount}
                            total={totalFeedbacks}
                            maxButtons={5}
                            activePage={page}
                            onChangePage={(page) => setPage(page)}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
}
export default Blinkit;
